/**
 * RODO — żądania osób (`gdprPage.*`), scalane przez `extra.ts`. `gdprPageEn` jest typowany względem `gdprPagePl`.
 */
export const gdprPagePl = {
  title: 'Dane osobowe (RODO)',
  subtitle: 'Obsługa żądań osób, których dane przetwarzamy: wyszukaj osobę, pobierz jej dane albo zanonimizuj je na jej wniosek.',
  searchLabel: 'Szukaj osoby',
  searchPlaceholder: 'Nazwisko, e-mail lub telefon (min. {min} znaki)…',
  hint: 'Obejmuje osoby kontaktowe klientów, osoby z leadów i pracowników z InsERT (urlopy). Wyniki są ograniczone do 25 pozycji — zawęź frazę, jeśli to za dużo.',
  type: { CONTACT: 'Kontakt klienta', LEAD: 'Lead', EMPLOYEE: 'Pracownik (InsERT)' },
  erasedBadge: 'Zanonimizowany',
  noResults: 'Brak osób pasujących do frazy.',
  tooShort: 'Wpisz co najmniej {min} znaki.',
  loadError: 'Nie udało się wyszukać osób.',
  actions: { export: 'Pobierz dane (JSON)', erase: 'Zanonimizuj' },
  exportDone: 'Dane osoby pobrane. Plik zawiera dane osobowe — przekaż go tylko osobie, której dotyczy.',
  exportError: 'Nie udało się pobrać danych.',
  erase: {
    title: 'Zanonimizować dane osobowe?',
    body: 'Imię, nazwisko, e-mail, telefon, stanowisko i notatki osoby „{name}” zostaną nieodwracalnie usunięte. Zgody zostają jako dowód, ale tracą powiązanie z osobą. Dane firmy „{org}” oraz historia sprzedaży i wizyt zostają.',
    confirmLabel: 'Aby potwierdzić, wpisz {word}',
    word: 'USUŃ',
    submit: 'Zanonimizuj nieodwracalnie',
    cancel: 'Anuluj',
    done: 'Dane osobowe zanonimizowane.',
    alreadyDone: 'Te dane były już zanonimizowane.',
    error: 'Nie udało się zanonimizować danych.',
  },
  scope: {
    title: 'Co obejmuje anonimizacja',
    items: {
      i0: 'Osoba kontaktowa klienta: imię, nazwisko, stanowisko, e-mail, telefon, notatki, oznaczenie osoby głównej.',
      i1: 'Lead: dane osoby kontaktowej (imię i nazwisko, e-mail, telefon, notatki); nazwa firmy zostaje.',
      i2: 'Podpis złożony przez tę osobę: imię i nazwisko podpisującego.',
      i3: 'Zgody (RODO, marketing): zostają jako dowód z datą i wersją tekstu, bez powiązania z osobą.',
      i4: 'Pracownik z InsERT (NX-421): imię i nazwisko, wymiar i daty urlopów — usunięte; import z Gratyfikanta ich nie odtworzy.',
    },
    keepTitle: 'Co zostaje (obowiązki prawne i uzasadniony interes)',
    keep: 'Dane firmy, dokumenty sprzedaży i należności, historia wizyt i zamówień. Każda czynność z tej strony trafia do dziennika audytu — bez danych osobowych.',
  },
};

export const gdprPageEn: typeof gdprPagePl = {
  title: 'Personal data (GDPR)',
  subtitle: 'Handle data subject requests: find a person, download their data or anonymize it on their request.',
  searchLabel: 'Find a person',
  searchPlaceholder: 'Last name, e-mail or phone (min. {min} characters)…',
  hint: 'Covers customer contact persons, people from leads and employees from InsERT (leave). Results are limited to 25 — narrow the search if there are too many.',
  type: { CONTACT: 'Customer contact', LEAD: 'Lead', EMPLOYEE: 'Employee (InsERT)' },
  erasedBadge: 'Anonymized',
  noResults: 'No people match the search.',
  tooShort: 'Enter at least {min} characters.',
  loadError: 'Could not search for people.',
  actions: { export: 'Download data (JSON)', erase: 'Anonymize' },
  exportDone: 'The person’s data was downloaded. The file contains personal data — hand it only to the person concerned.',
  exportError: 'Could not download the data.',
  erase: {
    title: 'Anonymize personal data?',
    body: 'First name, last name, e-mail, phone, position and notes of “{name}” will be irreversibly removed. Consents stay as evidence but lose the link to the person. The data of the company “{org}” and the sales and visit history stay.',
    confirmLabel: 'To confirm, type {word}',
    word: 'DELETE',
    submit: 'Anonymize irreversibly',
    cancel: 'Cancel',
    done: 'Personal data anonymized.',
    alreadyDone: 'This data was already anonymized.',
    error: 'Could not anonymize the data.',
  },
  scope: {
    title: 'What anonymization covers',
    items: {
      i0: 'Customer contact person: first name, last name, position, e-mail, phone, notes, primary-contact flag.',
      i1: 'Lead: the contact person data (name, e-mail, phone, notes); the company name stays.',
      i2: 'A signature made by that person: the signer’s name.',
      i3: 'Consents (GDPR, marketing): stay as evidence with date and text version, without the link to the person.',
      i4: 'Employee from InsERT (NX-421): name, leave entitlement and dates — removed; the Gratyfikant import will not restore them.',
    },
    keepTitle: 'What stays (legal obligations and legitimate interest)',
    keep: 'Company data, sales documents and receivables, visit and order history. Every action on this page is written to the audit log — without personal data.',
  },
};
